import { ShowOption as TooltipShowOption , Position as TooltipPosition } from "@progress/kendo-angular-tooltip";
export declare type ShowOption = TooltipShowOption;
export declare type Position = TooltipPosition;